/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Validdataschedule2Inputs */



/**
* | output |
* | --- |
* | "Valid data schedule" |
*
* @param {Br_History_Key_Validdataschedule2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_validdataschedule2 = /** @type {((inputs?: Br_History_Key_Validdataschedule2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Validdataschedule2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Valid data schedule")
	return /** @type {LocalizedString} */ ("Planning de données valides")
});
export { br_history_key_validdataschedule2 as "br_history_key_validDataSchedule" }